import {useState,useEffect} from 'react'
import { useStore } from '../../StoreContext';
import util from '@utils/utils'
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';
import {LoadingDiv } from '@components/LoadingDiv';
import { Search, FileText, X, ArrowRight, MessageSquare ,List,Plus,FileMinus,Minus,FilePlus} from 'react-feather';
export const CompareFiles = (props) => {
    const {searchInput,data,loading,selectedPolicies,handleSelectPolicy} = props
    const { state, actions } = useStore();

    const isSelected = (policy) => {
        return selectedPolicies.some(p => p && p.source_id === policy.source_id);
    };

    return (
        <>
            {/* <div className="indicator">
                <span className="indicator-item badge badge-neutral">{state?.length}</span>
                <button className="btn btn-primary text-white" onClick={()=>document.getElementById('my_policy_compare_modal').showModal()}>
                <SparkSvg/>

                    政策对比
                </button>
            </div> */}
            <dialog id="my_policy_compare_modal" className="modal">
                <div className="modal-box p-0 w-7/12 max-w-5xl max-h-4xl">
                    <div className="bg-white p-4 sticky top-0 z-30">
                        <div className="flex space-between items-center">
                            <h2 className="card-title pl-4">
                                【搜索结果】{searchInput}
                            </h2>
                            <form method="dialog">
                                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                            </form>
                        </div>
                    </div>
                    <div className='px-8 pb-8'>
                        {
                            loading ? 
                            <LoadingDiv/>
                            :
                            <div>
                                {
                                    data?.length > 0 ? 
                                    <div className='max-h-3xl overflow-y-auto space-y-2 pr-4'>
                                    {data?.map((policy, index) => {return (
                                            // <div className={`flex justify-between items-center w-full py-3 ${index===data?.length-1 ? '' : 'border-b'}`}>
                                            //     <div className='flex-1'>
                                            //         <div className='text-lg font-bold'>
                                            //             {item?.policy_name}
                                            //         </div>
                                            //         <div className='text-secondary flex gap-2'>
                                            //             <span>[{item.policy_class }]</span>
                                            //             <span>政策来源：{item?.from_organization?.replaceAll(/:/g,"")}</span>
                                            //             <span>{util.dateTransformToCN(item?.policy_time)}</span>
                                            //         </div>
                                            //     </div>
                                            //     <div>
                                            //     {
                                            //         files?.some(it => it?.source_id  === item?.source_id) ?
                                            //         <button className='btn btn-outline ml-6 btn-active w-36'
                                            //         onClick={()=>setFiles([...files?.filter(i=>i.source_id !== item?.source_id)])}>
                                            //             移除对比对象
                                            //         </button> :                                        
                                            //         <button className='btn btn-outline ml-6 w-36' disabled={files?.length>1}
                                            //         onClick={()=>setFiles([...files,item])}>
                                            //             加入对比对象
                                            //         </button>
                                            //     }
                                            //     </div>
                                            // </div>
                                            <div
                                            key={policy.source_id}
                                            className={`flex items-center justify-between py-3 px-6 rounded-lg transition-all duration-200 ${isSelected(policy)
                                                    ? 'bg-[#1ea18b]/5 border border-[#1ea18b]'
                                                    : 'bg-gray-50 hover:bg-gray-100'
                                                }`}
                                        >
                                            <div className='flex-1'>
                                                <div className='text-lg font-bold cursor-pointer hover:text-primary' 
                                                onClick={(e)=>{e.preventDefault();e.stopPropagation();
                                                    window.open(util.buildPolicyFileUrl(policy?.policy_title || policy?.policy_name, policy?.source_id, '', window.location.href),'_blank')}}>
                                                    {index+1}. {policy?.policy_title || policy?.policy_name}
                                                </div>
                                                <div className='text-secondary flex gap-2'>
                                                    <span>[{policy.large_policy_class }]</span>
                                                    <span>政策来源：{policy?.from_organization?.replaceAll(/:/g,"")}</span>
                                                    <span>{util.dateTransformToCN(policy?.policy_time)}</span>
                                                </div>
                                            </div>
                                            {isSelected(policy) ? (
                                                <span className="text-[#1ea18b] text-sm">已选择</span>
                                            ) : (
                                                <div className='flex items-center gap-4'>
                                                    { state?.some(i => i?.source_id	=== policy?.source_id) ? 
                                                    <div className="tooltip" data-tip="移出文件池">
                                                    <Minus className="w-5 h-5 text-[#1ea18b] cursor-pointer "
                                                        onClick={()=> actions.updateValue([...state?.filter(i=>i.source_id !== policy?.source_id)])                                                                        }
                                                    />
                                                    </div>
                                                        :
                                                    <div className="tooltip" data-tip="加入文件池">
                                                    <Plus className="w-5 h-5 text-[#1ea18b] cursor-pointer "
                                                        onClick={()=> actions.updateValue([policy,...state])                                                                        }
                                                    />
                                                    </div>}
                                                    <div className="tooltip" data-tip="添加对比对象">
                                                    <FilePlus className="w-5 h-5 text-[#1ea18b] cursor-pointer " 
                                                    onClick={() => !isSelected(policy) && handleSelectPolicy(policy, selectedPolicies[0] ? 1 : 0)}
                                                    />
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        )})} 
                                    </div>    
                                        :
                                    <div className="w-full text-center p-4">
                                        暂无内容
                                    </div>
                                }
                                {/* <div className='w-full text-center mt-2 sticky bottom-0 bg-base-100 p-4'>
                                    <button className='btn btn-outline'  disabled={files?.length !==2}
                                    onClick={()=>{
                                        const selectedCards = files?.map(i=>{return {policy_id:i?.source_id,policy_title:i.policy_name}})
                                        window.open(`${process.env.REACT_APP_DOMAIN}policy/compare?files=${encodeURIComponent(JSON.stringify(selectedCards))}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')
                                        setFiles([])
                                    }}          >
                                        开始对比
                                    </button>
                                </div> */}
                            </div>

                        }
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button>close</button>
                </form>
            </dialog>
        </>
    )
}